import { render, staticRenderFns } from "./AppNaverIcon.vue?vue&type=template&id=01d57c88"
import script from "./AppNaverIcon.vue?vue&type=script&lang=js"
export * from "./AppNaverIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports